import axios from 'axios'
axios.defaults.baseURL = `${process.env.REACT_APP_API_URL}/api`

const controller = 'Appointments'
const paginatedAndFilteredUrl = `${controller}/PaginatedAndFiltered`
const pendingAppointmentsUrl = `${controller}/Pending`
const appointmentsExcelUrl = `${controller}/Excel`

export const getAppointments = (filters) => {
  return axios.post(`/${paginatedAndFilteredUrl}`, filters)
}

export const getAppointment = (appointmentId) => {
  return axios.get(`/${controller}?appointmentId=${appointmentId}`)
}

export const createAppointment = (filters) => {
  return axios.post(`/${controller}`, filters)
}

export const updateAppointment = (filters) => {
  return axios.put(`/${controller}`, filters)
}

export const getPendingAppointments = (filters) => {
  return axios.post(`/${pendingAppointmentsUrl}`, filters)
}

export const downloadAppointmentsExcel = (data) => {
  return axios.post(appointmentsExcelUrl, data, {
    responseType: 'blob'
  })
}
